import React from 'react';

export const ApexDatePickerContext = React.createContext({ value: {} });